<template>
    <div>
        <v-layout align-center justify-center v-if="loading && items.length === 0">
            <v-flex xs12 class="text-xs-center">
                <v-progress-circular indeterminate :color="color"></v-progress-circular>
            </v-flex>
        </v-layout>
        <v-card v-if="!loading && items.length > 0" raised>
            <v-toolbar :color="color" dark>
                <v-toolbar-title>{{ titulo }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon flat @click="$router.push({name: 'presup.'+ tipo + '.add',params:{presup: presup,oper:'add'}})">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-toolbar>
            <v-data-table
                    v-if="items.length > 0"
                    :headers="encab"
                    :items="items"
                    hide-actions
                    class="elevation-1 tabla-compacta-col"
                    :loading="(loading)? 'red' : false"
                    :key="tipo"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">
                        <v-icon v-if="tipo === 'obb'" :color="props.item.estado.color" 
                                    >{{ props.item.estado.icono }}
                            </v-icon>
                        <v-tooltip top v-else>
                            <v-icon slot="activator" :color="props.item.estado.color"
                                    @click.stop="cambiaEstadoAbre(props.item)">{{ props.item.estado.icono }}
                            </v-icon>
                            <span>{{ props.item.estado.desig }}</span>
                        </v-tooltip>
                    </td>
                    <td class="text-xs-right">{{ props.item.ident }}</td>
                    <td class="text-xs-center">
                        <v-avatar :size="30">
                            <img :src="props.item.empresa.avatar" alt="avatar">
                        </v-avatar>
                    </td>
                    <td class="text-xs-center">{{ props.item.fecha_entrega | fecha }}</td>
                    <td class="text-xs-center" v-if="tipo === 'obr'">{{ props.item.obr_desc }}</td>
                    <td class="text-xs-center" v-if="tipo === 'cam'">{{ (props.item.camara_tipo == 'c')? 'CONVENCIONAL':'NO CONVENCIONAL' }}</td>
                    <td class="text-xs-center" v-if="tipo === 'cam'">{{ (props.item.camara_temp)?props.item.camara_temp.toUpperCase() : '' }}</td>
                    <td class="text-xs-left" v-if="tipo !== 'cam' && tipo !== 'obr'">{{ (props.item && props.item.item )? props.item.item.micro_id_1 : '' }} | {{ (props.item && props.item.item )? props.item.item.descripcion : ''}}</td>
                    <td class="text-xs-right" v-if="tipo === 'pan'">{{ props.item.cant_pza }}</td>
                    <td class="text-xs-right" v-if="tipo === 'pan'">{{ props.item.ancho | moneda}}</td>
                    <td class="text-xs-right" v-if="tipo === 'pan'">{{ props.item.largo_pza | moneda }}</td>
                    <td class="text-xs-right" v-if="tipo !== 'obr'">{{ props.item.cant | moneda }} | {{ props.item.um }}</td>
                    <td class="text-xs-right" v-if="tipo === 'cha'">{{ props.item.cant * props.item.largo_pza | moneda}}</td>
                    <td class="text-xs-right" v-if="tipo === 'obr'">{{ props.item.obr_presup }}</td>
                    <td class="text-xs-right" v-if="tipo === 'obr'">{{ props.item.obr_revision }}</td>
                    <td class="text-xs-right">{{ props.item.pu | moneda(moneda)}}</td>
                    <td class="text-xs-right">{{ props.item.subtotal | moneda(moneda) }}</td>
                    <td class="text-xs-center">
                        <v-btn flat icon color="blue" small
                               @click.native="$router.push({name: 'presup.' + tipo + '.edit' ,params:{presup: presup, id: props.item.ident, oper:'edit'}})">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-tooltip top>
                            <v-btn slot="activator" flat icon small color="orange"
                                   @click.native="solicitudDescuento(props.item)"
                                   v-if="!props.item.sol_desc || props.item.sol_desc === 0">
                                <v-icon>mail</v-icon>
                            </v-btn>
                            <span>Generar solicitud de descuento</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-icon v-if="props.item.sol_desc === 1" slot="activator" :color="solColor(props.item.sol_aprob)">flag</v-icon>
                            <span>{{ solTexto(props.item.sol_aprob) }}</span>
                        </v-tooltip>
                    </td>
                </template>
                <template slot="footer">
                    <td :colspan="this.encab.length - 4">
                        <strong v-if="tipo === 'pan'" class="mr-4">Total Piezas: {{ totalPza | moneda }}</strong>
                        <strong v-if="tipo === 'pan'">Total M2: {{ totalM2 | moneda }}</strong>
                    </td>
                    <td colspan="3" class="text-xs-right">
                        <strong>Total: {{ total | moneda(moneda) }}</strong>
                    </td>
                </template>
            </v-data-table>
            <!--    ESTADOS///////////////////////////////////////////////////////////////////////////-->
            <v-bottom-sheet v-model="sheet">
                <v-card tile>
                    <v-progress-linear :indeterminate="true" class="my-0" height="3" color="red" :active="cambiando"></v-progress-linear>
                    <v-list>
                        <v-subheader>Cambiar de estado el item {{ (cambioEstadoItem)? cambioEstadoItem.desc: '' }}</v-subheader>
                        <template v-for="e in estados">
                            <v-list-tile @click="verificaCambioEstado(e.id)">
                                <v-list-tile-action>
                                    <v-icon :color="e.color">{{ e.icono }}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ e.desig }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-card>

            </v-bottom-sheet>
            <!--    OBSERVACIONES/////////////////////////////////////////////////////////////////////-->
            <v-dialog v-model="observacionDiag" max-width="500px">
                <v-card>
                    <v-card-title primary-title class="headline grey lighten-2">Ingrese observación</v-card-title>
                    <v-card-text>
                        <v-textarea></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="observacionDiag=false">Cancelar</v-btn>
                        <v-btn color="primary" flat @click="cambiaEstado(estadoSeleccionado)">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--    SOLICITUD DE DECUENTO ///////////////////////////////////////////////////////////-->
            <v-dialog v-model="solicitudDiag" max-width="500px">
                <v-card>
                    <v-card-title primary-title class="headline grey lighten-2">Ingrese los montos a solicitar</v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-text-field label="Descuento comercial"
                                                  v-model="s.sol_desc_com"
                                                  hint="Porcentaje máximo que desea aplicar"
                                                  persistent-hint></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-text-field label="Descuento estratégico" v-model="s.sol_desc_est"
                                                  hint="Porcentaje máximo que desea aplicar"
                                                  persistent-hint></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" flat @click="solicitudDiag=false">Cancelar</v-btn>
                        <v-btn color="green" flat @click="solicitudGenera()" :loading="solicitudLoading">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
        <br v-if="items.length > 0">
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import moneda from '../filters/moneda';
    import fecha from '../filters/fecha';
    import mixinPresupItem from '../mixins/presupuestoItems';
    import mixinPresup from '../mixins/presupuesto';
    import mixinConfig from '../mixins/config';

    export default {
        name: "tabla-items",
        props: ['tipo', 'presup', 'moneda', 'titulo', 'color'],
        mixins: [mixinPresupItem, mixinPresup, mixinConfig],
        filters: {moneda, fecha},
        data() {
            return {
                headers: [
                    {text: 'Estado', value: 'estado_id', align: 'center'},
                    {text: 'ID', value: 'ident', align: 'center'},
                    {text: 'Empresa', value: 'empresa_id', align: 'center'},
                    {text: 'Fecha Entrega', value: 'fecha_entrega', align: 'center'},
                    {text: 'Item', value: 'item_id', align: 'center'},
                    {text: 'Cantidad', value: 'cant', align: 'center'},
                    {text: 'Precio Unitario', value: 'pu', align: 'center'},
                    {text: 'Subtotal', value: 'subtotal', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                items: [],
                loading: false,
                sheet: false,
                sheetNuevoItem: false,
                estados: [],
                cambioEstadoItem: [],
                cambioEstadoEstado: {},
                cambiando: false,
                observacionDiag: false,
                estadoSeleccionado: '',
                solicitudDiag: false,
                s: {
                    sol_desc_com: 0,
                    sol_desc_est: 0,
                    presupuesto_id: '',
                    item_id: ''
                },
                solicitudLoading: false
            }
        },
        computed: {
            encab() {
                switch (this.tipo) {
                    case 'cha':
                        this.headers.splice(5, 0, {text: 'Largo', value: '', align: 'center'});
                        break;
                    case 'pan':
                        this.headers.splice(5, 0, {text: 'Cant pza(mts)', value: 'cant_pza', align: 'center'});
                        this.headers.splice(6, 0, {text: 'Ancho(mts)', value: 'ancho', align: 'center'});
                        this.headers.splice(7, 0, {text: 'Largo pza(mts)', value: 'largo_pza', align: 'center'});
                        this.headers.splice(8, 1, {text: 'Cant(mts2)', value: 'cant', align: 'center'});
                        break;
                    case 'cam':
                        this.headers.splice(3, 1, {text: 'Tipo', value: 'camara_tipo', align: 'center'});
                        this.headers.splice(4, 0, {text: 'Temp', value: 'camara_temp', align: 'center'});
                        break;
                    case 'obr':
                        this.headers.splice(3, 1, {text: 'Descripcion', value: 'obr_desc', align: 'center'});
                        this.headers.splice(4, 1, {text: 'Presup OPI', value: 'obr_presup', align: 'center'});
                        this.headers.splice(5, 0, {text: 'Revisión', value: 'obr_revision', align: 'center'});
                        break;
                    default:
                        return this.headers;
                }
                return this.headers;
            },
            total() {
                return this.items.reduce((a, b) => {
                    return a + ((b.estado_id !== 6) ? b.subtotal : 0);
                }, 0)
            },
            totalM2() {
                return this.items.reduce((a, b) => {
                    return a + ((b.estado_id !== 6) ? b.cant : 0);
                }, 0);
            },
            totalPza() {
                return this.items.reduce((a, b) => {
                    return a + ((b.estado_id !== 6) ? b.cant_pza : 0);
                }, 0);
            }
        },
        mounted() {
            this.getItems();
            this.getEstados();
            //obtengo configuracion sobre estados que se observarn
            this.configGet('estadoObs', r => {
                this.estadoObs = r;
            }, err => {
                console.log(err)
            });
            this.$bus.$on('actualizarTablaItems', (presup) => {
                this.getItems();
            })
        },
        beforeDestroy() {
            this.$bus.$off('actualizarTablaItems');
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            solColor(aprob) {
                if (aprob === 0) {
                    return 'yellow';
                } else if (aprob === 1) {
                    return 'green'
                } else {
                    return 'red'
                }
            },
            solTexto(aprob) {
                if (aprob === 0) {
                    return 'Solicitud pendiente de aprobación';
                } else if (aprob === 1) {
                    return 'Solicitud aprobada'
                } else {
                    return 'Solicitud rechazada'
                }
            },
            getItems() {
                this.loading = true;
                this.presupuestoItemLista({presupuesto_id: this.presup, tipo_id: this.tipo}, r => {
                    this.items = r;
                    this.loading = false;
                }, err => {
                    console.log(err)
                })
            },
            getEstados() {
                this.estadosListado(r => {
                    this.estados = r;
                }, err => {
                    console.log(err)
                })
            },
            cambiaEstadoAbre(item) {
                this.cambioEstadoItem = [];
                this.cambioEstadoItem.push(item.ident);
                this.sheet = true;
            },
            verificaCambioEstado(estado) {
                this.estadoSeleccionado = estado;
                if (this.estadoObs.includes(estado)) {
                    this.observacionDiag = true;
                } else {
                    this.cambiaEstado(estado);
                }
            },
            cambiaEstado(estado) {
                this.observacionDiag = false;
                this.cambiando = true;
                this.presupuestoItemCambiaEstado({estado: estado, items: this.cambioEstadoItem},
                    r => {
                        this.getItems();
                        this.msjShow(r);
                        this.cambiando = false;
                        this.sheet = false;
                        this.$bus.$emit('cambioEstado')
                    }, err => {
                        console.log(err);
                        this.cambiando = false;
                    })
            },
            solicitudDescuento(item) {
                this.solicitudDiag = true;
                this.s.presupuesto_id = item.presupuesto_id;
                this.s.item_id = item.ident;
            },
            solicitudGenera() {
                this.solicitudLoading = true;
                this.presupuestoItemSolicitudDesc(this.s, r => {
                    this.solicitudLoading = false;
                    this.msjShow(r)
                    this.solicitudDiag = false;
                    this.getItems();
                }, err => {
                    this.solicitudLoading = true;
                    console.error(err)
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TablaItems.vue